module.exports = __webpack_public_path__ + "static/media/temp_w_domu_off_3.306794ff.svg";